import React from "react";
import QTSI from "./QTSI";

function App() {
  return <QTSI />;
}

export default App;
